// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"a677dd8a","156":"a31f658e","219":"63d4c845","371":"8a968a5e","453":"5d9d47fd","597":"acc442d5","909":"d3899af1"}[chunkId] + ".chunk.js";
};